import { makeAutoObservable, runInAction } from 'mobx'
import { logger } from 'shared/lib'
import type { IEntitiesStore } from 'entities/EntitiesExport'

export class IntegrationsAccessStore {
  private _loading = true

  constructor(private _entities: IEntitiesStore) {
    makeAutoObservable(this)
  }

  init = async () => {
    runInAction(() => {
      this._loading = true
    })

    try {
      await Promise.all([
        this._entities.featureFlagsStore.fetchFeatureFlags(),
        this._entities.userPermissionsStore.initPromise,
      ])
    } catch (error) {
      logger.error(error)
    } finally {
      runInAction(() => {
        this._loading = false
      })
    }
  }

  get loading() {
    return this._loading
  }
}
